/**
 * What the server returns in place of a saved credential in a client configuration. Sending it back unchanged keeps
 * the saved value; any other value replaces it. Must match ClientConfigurationCredentials.Masked on the server.
 */
export const MASKED_CREDENTIAL = "••••••••";
